import { render, staticRenderFns } from "./ChooseQuestion.vue?vue&type=template&id=04a3c8f0&"
import script from "./ChooseQuestion.vue?vue&type=script&lang=js&"
export * from "./ChooseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports